export default __webpack_public_path__ + "locales/pt/ChangePhoneDialog.json?hash=a0d614c59e27f126e18b131b297eafd8";